import { HTMLAttributes, ReactNode } from 'react'
import { SeoHead, type SeoProps } from '@/shared/seo/SeoHead'

export type TemplateProps = {
    children: ReactNode
    metadata?: SeoProps
} & HTMLAttributes<HTMLDivElement>

const DefaultTemplate = ({ children, metadata, ...others }: TemplateProps) => {
    return (
        <div {...others}>
            {metadata ? <SeoHead {...metadata} /> : null}
            {children}
        </div>
    )
}

export default DefaultTemplate
